exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-124a2bf2] .van-popup--bottom{width:50%;left:25%}", ""]);
